import { createFileRoute } from '@tanstack/react-router';

import { ElementForm } from './-components/ElementForm';

export const Route = createFileRoute('/_authenticated/rtelements/new')({
    component: ElementForm,
});
